import JobTimelineEntry from './JobTimelineEntry';
import { observable, makeObservable } from 'mobx';
import Employee from 'main/stores/employees/Employee';
import {oneOf} from 'shared/store';
import {types} from 'main/tools';

class TerminationRecord extends JobTimelineEntry {
  lastDayOfBenefits;
  lastDayOfWork;
  terminationReason;
  reassignReportsTo;
  terminationType;
  employeeHasBenefits;
  proofOfExtension;
  roeCode;
  reasonForQuitting;
  terminatedOnProbation;

  // Termination fields
  terminatedAt;
  sendToAdmin;
  personalEmail;
  reassignReportsToEmployeeId;
  withinESARequirements;

  _relations = {
    ...this._relations,
    terminationType: oneOf(['voluntary', 'involuntary']),
    reassignReportsTo: Employee,
    _dates: [...this._relations._dates, 'lastDayOfBenefits', 'lastDayOfWork']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      lastDayOfBenefits: observable,
      lastDayOfWork: observable,
      terminationReason: observable,
      reassignReportsTo: observable,
      terminationType: observable,
      employeeHasBenefits: observable,
      proofOfExtension: observable,
      roeCode: observable,
      reasonForQuitting: observable,
      terminatedOnProbation: observable,
      terminatedAt: observable,
      sendToAdmin: observable,
      personalEmail: observable,
      reassignReportsToEmployeeId: observable,
      withinESARequirements: observable
    });

    this.merge(other);
  }

  _afterMerge() {
    this._type = types.TERMINATION_RECORD;
  }
}

export default TerminationRecord;
